/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./Header.module.css";

function Header() {
  return (
    <header className={styles.header}>
      <a href="/" className="cursor-pointer">
        <img
          loading="lazy"
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/664b3b98ce09e67c7c84611c2a2bc412b875f619e98e4e40d6c9c8b326ae106f?placeholderIfAbsent=true&apiKey=e6e279f9e06842139b3f7c01a7502bdc"
          alt="Store icon"
          className={styles.storeIcon}
        />
      </a>
      <div className={styles.storeInfo}>
        <h2>Gulmatico 2nd hand clothing store</h2>
        <p className={styles.onlineShop}>Online Shop</p>
      </div>
    </header>
  );
}

export default Header;
